import { CardInterface } from '../../models/card.interface';

export interface CardsInterfaceState {
  cards: Array<CardInterface>;
}

export const initialCardState: CardsInterfaceState = {
  cards: null
};
